import "./GuideLines.css";
export default function Guidelines(){
    return (
        <div className="contest-guidelines">
          <h1>Workshop Guidelines</h1>
          <div className="contest-guidelines-spacing">
          <hr></hr>

          <ol>
            <li>
              <strong>Login and Registration</strong>
              <ul>
                <li>All participants must log in to the website using their <span style={{"color": "red"}}>ADYPU Google account</span>.</li>
                <li>
                  Once logged in, participants will gain access to the contest dashboard where
                  they can:
                  <ul>
                    <li>Read contest rules.</li>
                    <li>Write, submit, and test their strategy.</li>
                    <li>View the leaderboard.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Writing and Testing Your Strategy</strong>
              <ul>
                <li>
                  <strong>Accessing the Code Editor:</strong>
                  <ul>
                    <li>Click the <span style={{"color": "red"}}>"Question link"</span> button for your respective batch on the dashboard to access the Newton code editor.</li>
                    <li>Save and test your code in the editor.</li>
                  </ul>
                </li>
                <li>
                  <strong>Submitting on Newton Platform:</strong>
                  <ul>
                    <li>Submit your strategy on the <span style={{"color": "red"}}>Newton Platform</span> for predefined test cases.</li>
                    <li>
                      Test cases will verify:
                      <ul>
                        <li>Correctness of your strategy.</li>
                        <li>Compliance with time and memory limits.</li>
                      </ul>
                    </li>
                    <li>
                      After submission, return to the DSA Open-Book Workshop dashboard.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Returning to Contest Dashboard:</strong>
                  <ul>
                    <li>
                    <span style={{"color": "red"}}> If your strategy passes all test cases on newton platform, use the "Test My Strategy" button to submit for competition (Mandatory Step).</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Competing Against Others</strong>
              <ul>
                <li>
                  Teams will bid for multiple resources in each round.
                </li>
                <li>
                  Points (Per Resource) will be awarded as per the contest rules:
                  <ul>
                    <li>Higher bid wins the resource and earns <span style={{"color": "red"}}>3</span> points.</li>
                    <li>Equal bids result in a draw; both teams earn <span style={{"color": "red"}}>1</span> point.</li>
                    <li>Lower bid results in a loss and earns <span style={{"color": "red"}}>0</span> points.</li>
                  </ul>
                </li>
                <li>
                  Bonus Points (After all resources are evaluated):
                  <ul>
                    <li>Team winning more resources earns an additional <span style={{"color": "red"}}>3 × N</span> bonus points.</li>
                    <li>If both teams win an equal number of resources, both receive <span style={{"color": "red"}}>N</span> bonus points.</li>
                    <li>Team with fewer wins receives <span style={{"color": "red"}}>0</span> bonus points.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Leaderboard Updates</strong>
              <ul>
                <li>
                <span style={{"color": "red"}}>  The updates on the leaderboard happens periodically and not immediately (at runtime).
                  you will be notified about the same on slack channel...  </span>
                </li>
                <li>Rankings will display:</li>
                <ul>
                  <li>Participant name or alias. </li>
                  <li>ADYPU Email</li>
                  <li>Total points.</li>
                  <li>Rank.</li>
                  <li>Code.</li>
                </ul>
              </ul>
            </li>
            <li>
              <strong>Iteration and Resubmission</strong>
              <ul>
                <li>Participants can improve their strategies until the contest ends.</li>
                <li>
                  Use the Newton Platform to refine code before resubmitting.
                </li>
                <li>
                  Each resubmission will retest the strategy, and the leaderboard will update accordingly.
                </li>
              </ul>
            </li>
            <li>
              <strong>Rules and Conduct</strong>
              <ul>
                <li>
                  Strategies must adhere to these guidelines:
                  <ul>
                    <li>Do not exploit the platform or interfere with other participants.</li>
                    <li>Comply with time and memory limits.</li>
                    <li>Collaborating is allowed, but plagiarism will result in disqualification.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Contest Timeline</strong>
              <ul>
                <li><span style={{"color": "red"}}>The contest runs for two weeks;</span> submissions close at the end time.</li>
                <li>The leaderboard will freeze in the final hour to maintain suspense.</li>
                <li>Winners will be announced after the contest ends.</li>
              </ul>
            </li>
            <li>
              <strong>Rewards</strong>
              <ul>
                <li>Top participants will receive prizes based on the final leaderboard.</li>
                <li>Extra credit points may be awarded.</li>
              </ul>
            </li>
          </ol>
          </div>
        </div>
      );
}










